<div class="form-group mb-3">
  <label for="Input3" class="form-label">{{'Language'|translate}}</label>
  <select id="Input3" class="form-select" aria-label="Language "
          (change)="selectionLangChange($event.target.value)">
    <option *ngFor="let unit of lang.langItems; index as i" [value]="unit?.value"
            [selected]="unit.value == defaultLanguage.value">
      {{ unit.text }}
    </option>
  </select>
</div>
